import { Component } from '@angular/core';

@Component({
	selector: 'app-spinner',
	imports: [],
	templateUrl: './spinner.component.html',
	styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {}
